import "core-js/modules/es.array.push.js";
import { ref } from 'vue';
import { Search, Popup, Button, Checkbox, CheckboxGroup, Tab, Tabs, Col, Row, closeToast, showLoadingToast, showDialog } from 'vant';
import { useRouter } from 'vue-router';
import { postue } from '../../api/utils/request.ts';
export default {
  setup() {
    const currentType = ref('');
    const curType = ref('');
    const checkedlist = ref([]);
    const showScreen = ref(false);
    const sortType = ref('asc');
    const condition = ref('');
    const toggleScreen = t => {
      curType.value = t;
      showScreen.value = true;
    };
    return {
      currentType,
      condition,
      curType,
      showScreen,
      checkedlist,
      toggleScreen,
      sortType
    };
  },
  data() {
    return {
      MyDeviceListForShow: [],
      sizeplus: 10,
      excavatorSizeslist: [],
      macTypelist: [],
      tagList: [],
      checkMacTypes: [],
      checkTags: []
    };
  },
  created() {
    //在组件实例处理完所有与状态相关的选项后调用。
    console.log('created');
  },
  mounted() {
    //在组件被挂载之后调用 
    console.log('mounted');
    this.getDeviceShow(10);
    this.GetOtherMacType();
  },
  methods: {
    selectClick: function () {
      this.getDeviceShow(this.sizeplus), this.toggleScreen0();
    },
    toggleScreen0: function () {
      this.showScreen = false;
    },
    orderBy: function (t) {
      this.curType = '';
      this.showScreen = false;
      this.currentType = 'PushTime';
      var s = this.sortType;
      this.sortType = s == 'desc' ? 'asc' : 'desc';
      this.getDeviceShow(this.sizeplus);
    },
    reset: function () {
      if (this.curType == 'mac') {
        this.checkMacTypes = [];
      }
      if (this.curType == 'tag') {
        this.checkTags = [];
      }
    },
    getDeviceShow: function (Psize) {
      showLoadingToast({
        message: '加載中...',
        forbidClick: true,
        duration: 0
      });
      console.log(this.checkMacTypes);
      console.log(this.checkTags);
      //设备展示		
      // var param = {
      //     PageIndex:1,PageSize:Psize,
      //     sidx:"D_PushTime",sord:this.sortType,
      //     MacTypeList:this.checkMacTypes,
      //     TagList: this.checkTags,
      //             BrandList: [],
      //             ExcavatorSizeList: [],
      //             Province:'',
      //             City: '',
      //             DrivingModeList:[],
      //             PlatformHighList: []
      // };
      var param = {
        PageIndex: 1,
        PageSize: Psize,
        sidx: "D_PushTime",
        sord: this.sortType,
        ModelOrBrand: this.condition,
        MacTypeList: this.checkMacTypes,
        TagList: this.checkTags,
        Status: ""
      };
      postue('Auction/RTBV2/RTBActListV2', param).then(res => {
        console.log(res);
        this.MyDeviceListForShow = res.data.rows;
        closeToast();
      });
    },
    onSearch: function () {
      this.getDeviceShow(this.sizeplus);
    },
    //設備
    TagcheckChange_mac: function (e) {
      if (e == "全部設備") {
        this.checkMacTypes = ['全部設備'];
        return !1;
      } else if (this.checkMacTypes.includes('全部設備')) {
        this.checkMacTypes.pop();
      }
      if (this.checkMacTypes.includes(e)) {
        this.checkMacTypes.splice(this.checkMacTypes.indexOf(e), 1);
      } else {
        this.checkMacTypes.push(e);
      }
    },
    //標籤
    TagcheckChange_tag: function (e) {
      if (e == "全部標籤") {
        this.checkTags = ['全部標籤'];
        return !1;
      } else if (this.checkTags.includes('全部標籤')) {
        this.checkTags.pop();
      }
      if (this.checkTags.includes(e)) {
        this.checkTags.splice(this.checkTags.indexOf(e), 1);
      } else {
        this.checkTags.push(e);
      }
      // if (this.checkTags.includes(e)) {
      //     this.checkTags.splice(this.checkTags.indexOf(e),1);}
      // else {
      // this.checkTags.push(e);
      //     } 
    },

    GetOtherMacType: function () {
      postue('Auction/RTBV2/GetSearchConditon', {}).then(res => {
        console.log(res);
        if (res.code == 1) {
          this.macTypelist = res.data.MacTypes;
          this.tagList = res.data.Tags;
        }
      });
    },
    goShowdetail: function (item) {
      console.log(item);
      this.$router.push({
        path: 'UEdetail',
        query: {
          kid: item.C_ASTActivityId
        }
      });
    }
  }
};